import { NgModule } from '@angular/core';
import { FbqGgProductPageEventModule } from './analytics/fbq/page/product/fbq-gg-product-page-event.module';
import { FbqGgCategoryPageEventModule } from './analytics/fbq/page/category/fbq-gg-category-page-event.module';
import { FbqGgCartPageEventModule } from './analytics/fbq/page/cart/fbq-gg-cart-page-event.module';
import { FbqGgSearchPageEventModule } from './analytics/fbq/page/search/fbq-gg-search-page-event.module';
import { FbqGgOrderPlacedEventModule } from './analytics/fbq/order/fbq-gg-order-placed-event.module';
import { FbqGgCartAddEntrySuccessEventModule } from './analytics/fbq/cart/add/fbq-gg-cart-add-entry-success-event.module';
import { GtmGgProductPageEventModule } from './analytics/gtm/page/product/gtm-gg-product-page-event.module';
import { GtmGgCategoryPageEventModule } from './analytics/gtm/page/category/gtm-gg-category-page-event.module';
import { GtmGgSearchPageEventModule } from './analytics/gtm/page/search/gtm-gg-search-page-event.module';
import { GtmGgCartPageEventModule } from './analytics/gtm/page/cart/gtm-gg-cart-page-event.module';
import { GtmGgOrderPlacedEventModule } from './analytics/gtm/order/gtm-gg-order-placed-event.module';
import { GtmGgCheckoutPageEventModule } from './analytics/gtm/page/checkout/gtm-gg-checkout-page-event.module';
import { GtmGgCartAddEntrySuccessEventModule } from './analytics/gtm/cart/add/gtm-gg-cart-add-entry-success-event.module';
import { GtmGgCartRemoveEntrySuccessEventModule } from './analytics/gtm/cart/remove/gtm-gg-cart-remove-entry-success-event.module';
import { GtmGgCartUpdateEntrySuccessEventModule } from './analytics/gtm/cart/update/gtm-gg-cart-update-entry-success-event.module';
import { Ga4GgProductPageEventModule } from './analytics/ga4/page/product/ga4-gg-product-page-event.module';
import { Ga4GgCartAddEntrySuccessEventModule } from './analytics/ga4/cart/add/ga4-gg-cart-add-entry-success-event.module';
import { Ga4GgCartUpdateEntrySuccessEventModule } from './analytics/ga4/cart/update/ga4-gg-cart-update-entry-success-event.module';
import { Ga4GgCartRemoveEntrySuccessEventModule } from './analytics/ga4/cart/remove/ga4-gg-cart-remove-entry-success-event.module';
import { Ga4GgCheckoutReviewPageEventModule } from './analytics/ga4/page/checkout/ga4-gg-checkout-review-page-event.module';
import { Ga4GgUserLoginEventModule } from './analytics/ga4/user/login/ga4-gg-user-login-event.module';
import { Ga4GgCartPageEventModule } from './analytics/ga4/page/cart/ga4-gg-cart-page-event.module';
import { Ga4GgListingPageEventModule } from './analytics/ga4/page/listing/ga4-gg-listing-page-event.module';

@NgModule({
  imports: [
    GtmGgProductPageEventModule,
    GtmGgCategoryPageEventModule,
    GtmGgSearchPageEventModule,
    GtmGgCartPageEventModule,
    GtmGgOrderPlacedEventModule,
    GtmGgCheckoutPageEventModule,
    GtmGgCartAddEntrySuccessEventModule,
    GtmGgCartRemoveEntrySuccessEventModule,
    GtmGgCartUpdateEntrySuccessEventModule,
    FbqGgProductPageEventModule,
    FbqGgCategoryPageEventModule,
    FbqGgCartPageEventModule,
    FbqGgSearchPageEventModule,
    FbqGgOrderPlacedEventModule,
    FbqGgCartAddEntrySuccessEventModule,
    Ga4GgProductPageEventModule,
    Ga4GgCartAddEntrySuccessEventModule,
    Ga4GgCartUpdateEntrySuccessEventModule,
    Ga4GgCartRemoveEntrySuccessEventModule,
    Ga4GgCheckoutReviewPageEventModule,
    Ga4GgUserLoginEventModule,
    Ga4GgCartPageEventModule,
    Ga4GgListingPageEventModule,
  ],
})
export class EventsModule {}
